/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MilestoneCreateRequest
 */
export interface MilestoneCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof MilestoneCreateRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneCreateRequest
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof MilestoneCreateRequest
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MilestoneCreateRequest
     */
    dueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof MilestoneCreateRequest
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneCreateRequest
     */
    effectTenantId?: string;
    /**
     * 
     * @type {number}
     * @memberof MilestoneCreateRequest
     */
    sequence?: number;
    /**
     * 
     * @type {string}
     * @memberof MilestoneCreateRequest
     */
    remarks?: string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneCreateRequest
     */
    assignee?: string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneCreateRequest
     */
    priority?: string;
    /**
     * 
     * @type {number}
     * @memberof MilestoneCreateRequest
     */
    allocatedAmount?: number;
}

/**
 * Check if a given object implements the MilestoneCreateRequest interface.
 */
export function instanceOfMilestoneCreateRequest(value: object): value is MilestoneCreateRequest {
    return true;
}

export function MilestoneCreateRequestFromJSON(json: any): MilestoneCreateRequest {
    return MilestoneCreateRequestFromJSONTyped(json, false);
}

export function MilestoneCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MilestoneCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'dueDate': json['dueDate'] == null ? undefined : (new Date(json['dueDate'])),
        'status': json['status'] == null ? undefined : json['status'],
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
        'sequence': json['sequence'] == null ? undefined : json['sequence'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'assignee': json['assignee'] == null ? undefined : json['assignee'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'allocatedAmount': json['allocatedAmount'] == null ? undefined : json['allocatedAmount'],
    };
}

export function MilestoneCreateRequestToJSON(json: any): MilestoneCreateRequest {
    return MilestoneCreateRequestToJSONTyped(json, false);
}

export function MilestoneCreateRequestToJSONTyped(value?: MilestoneCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'dueDate': value['dueDate'] == null ? undefined : ((value['dueDate']).toISOString()),
        'status': value['status'],
        'effectTenantId': value['effectTenantId'],
        'sequence': value['sequence'],
        'remarks': value['remarks'],
        'assignee': value['assignee'],
        'priority': value['priority'],
        'allocatedAmount': value['allocatedAmount'],
    };
}

